<template>
  <div class="products text-light flex-column">
    <div class="background bg-1">
      <img :src="require(`@/assets/capas/${$route.params.categoria}.webp`)">
    </div>
    <header>
        <div v-if="$route.params.categoria === 'comodas-e-penteadeiras'" class="title title-1">Cômodas e Penteadeiras</div>
        <div v-if="$route.params.categoria === 'colchoes'" class="title title-1">Colchões</div>
        <div v-else>
          <div v-if="$route.params.categoria !== 'comodas-e-penteadeiras'" class="title title-1">{{ $route.params.title || $route.params.categoria | capitalize }}</div>
        </div>
    </header>
    <div class="content text-tertiary flex justify-space-around">
      <div class="filters flex-column">
        <div class="flex">
          <label for="searchProduct">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.5422 18.3584L13.9627 12.7789C14.8285 11.6596 15.2969 10.291 15.2969 8.85156C15.2969 7.12852 14.6244 5.51289 13.4084 4.29473C12.1924 3.07656 10.5725 2.40625 8.85156 2.40625C7.13066 2.40625 5.51074 3.07871 4.29473 4.29473C3.07656 5.51074 2.40625 7.12852 2.40625 8.85156C2.40625 10.5725 3.07871 12.1924 4.29473 13.4084C5.51074 14.6266 7.12852 15.2969 8.85156 15.2969C10.291 15.2969 11.6574 14.8285 12.7768 13.9648L18.3563 19.5422C18.3726 19.5586 18.392 19.5715 18.4134 19.5804C18.4348 19.5893 18.4577 19.5938 18.4809 19.5938C18.504 19.5938 18.5269 19.5893 18.5483 19.5804C18.5697 19.5715 18.5891 19.5586 18.6055 19.5422L19.5422 18.6076C19.5586 18.5913 19.5715 18.5718 19.5804 18.5505C19.5893 18.5291 19.5938 18.5062 19.5938 18.483C19.5938 18.4599 19.5893 18.4369 19.5804 18.4156C19.5715 18.3942 19.5586 18.3748 19.5422 18.3584ZM12.2547 12.2547C11.3438 13.1635 10.1363 13.6641 8.85156 13.6641C7.5668 13.6641 6.35938 13.1635 5.44844 12.2547C4.53965 11.3438 4.03906 10.1363 4.03906 8.85156C4.03906 7.5668 4.53965 6.35723 5.44844 5.44844C6.35938 4.53965 7.5668 4.03906 8.85156 4.03906C10.1363 4.03906 11.3459 4.5375 12.2547 5.44844C13.1635 6.35938 13.6641 7.5668 13.6641 8.85156C13.6641 10.1363 13.1635 11.3459 12.2547 12.2547Z" fill="#505050"/>
            </svg>
          </label>
          <input type="text" id="searchProduct" placeholder="Pesquisar" v-model="searchProduct">
        </div>
        <div id="checkbox" class="flex-column">
          <button class="btn-outlined" style="font-size: 14px" @click="removeFilters">Limpar Filtros</button>
          <div v-for="(filter, index) in currentFilters" :key="index" class="checkbox-group flex-column align-left">
            <div class="subtitle-1">{{ filter.title }}</div>
            <div class="flex-column align-left body-3">
              <div v-for="(checkbox, check_index) in filter.checkboxes" :key="check_index" class="checkbox">
                <div class="check-input">
                  <input
                    type="checkbox"
                    v-model="inputsCheck[index+checkbox]"
                    @change="checkFilter(checkbox, filter.options ? filter.options[check_index] : null)"
                    :id="'check-' + filter.title.split(' ').join('-').toLowerCase() + check_index"
                  >
                  <label :for="'check-' + filter.title.split(' ').join('-').toLowerCase() + check_index">{{ checkbox | maxString }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-column align-center" style="min-width: 60vw; max-width: 760px;">
        <div class="labels body-4 text-primary">
          <router-link
            :to="{ path: label.value }"
            class="label"
            :class="label.value == $route.params.categoria ? 'd-none' : ''"
            v-for="(label, index) in labels"
            :key="index"
          >
            {{ label.label }}
          </router-link>
        </div>
        <div class="products-grid">
          <div class="product" v-for="(product, index) in collection" :key="index">
            <router-link class="image gradient" :to="{ name: 'Details', params: { id: getProductIndex(product), categoria: $route.params.categoria } }">
              <div>
                <img
                  :src="getProductImage(product)"
                  :style="$route.params.categoria === 'roupeiros' ? 'transform: scale(1);' : 'transform: scale(1.2);'"
                  :alt="product.name"
                >
              </div>
            </router-link>
            <div class="name body-4">
              {{ product.name }}
            </div>
          </div>
        </div>
        <div v-if="products.length > 0" class="flex-column align-center">
          <div class="pagination flex align-center">
            <svg @click="backPage" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.7" d="M6 11L1 6L6 1" stroke="#505050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <button
              v-for="page in pagination.pages"
              :key="page"
              @click.prevent="setPage(page)"
              :class="page == pagination.currentPage ? 'active' : ''"
            >
              {{ page }}
            </button>
            <svg @click="nextPage" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.7" d="M1 11L6 6L1 1" stroke="#505050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="body-4">
            Mostrando {{ pagination.startIndex+1 }} até {{ pagination.endIndex+1 }} de {{ products.length }}
          </div>
        </div>
        <div v-else>
          <br>
          Nenhum item encontrado!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import api from '@/services/api'

export default {
  name: 'Products',
  data () {
    return {
      loading: true,
      // Dados da API
      apiCategory: null,
      apiProducts: [],
      apiFilters: [],
      // Labels para navegação entre categorias
      labels: [
        { label: 'COLCHÕES', value: 'colchoes' },
        { label: 'ROUPEIROS', value: 'roupeiros' },
        { label: 'ESTOFADOS', value: 'estofados' },
        { label: 'COZINHAS', value: 'cozinhas' },
        { label: 'CÔMODAS', value: 'comodas-e-penteadeiras' },
        { label: 'ESCRIVANINHAS', value: 'escrivaninhas' }
      ],
      searchProduct: null,
      inputsCheck: {},
      filtersChecked: [],
      selectedSpecs: [], // Valores das specs selecionadas para API
      perPage: 16,
      pagination: {}
    }
  },
  async created () {
    await this.fetchProducts()
    this.setPage(1)
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    formatProduct: function (product) {
      return product.split(' ').join('-').toLowerCase()
    },
    maxString: function (string) {
      if (string.length > 35) {
        return string.slice(0, 32) + '...'
      }
      return string
    }
  },
  watch: {
    async routeLocal () {
      this.removeFilters()
      const grid = document.querySelector('.products-grid')
      if (grid) grid.classList.add('products-loading')
      await this.fetchProducts()
      setTimeout(() => {
        const gridEl = document.querySelector('.products-grid')
        if (gridEl) gridEl.classList.remove('products-loading')
      }, 1000)
    },
    searchProduct (value) {
      this.setPage(1)
    }
  },
  computed: {
    products () {
      // Usa apenas dados da API (vazio se não retornar)
      const list = this.apiProducts.map(p => ({
        name: p.name,
        slug: p.slug,
        particulars: p.specifications || [],
        primaryImageUrl: p.primaryImage?.url || null
      }))

      // Busca por nome
      if (this.searchProduct && this.searchProduct !== '') {
        return list.filter(p => p.name.toLowerCase().includes(this.searchProduct.toLowerCase()))
      }

      return list
    },
    collection () {
      return this.paginate(this.products)
    },
    // Usa filtros da API (formato flat: array de {id, value})
    currentFilters () {
      if (!this.apiFilters || this.apiFilters.length === 0) return []
      // Cria um único grupo "Especificações" com todos os filtros
      return [{
        title: 'Especificações',
        checkboxes: this.apiFilters.map(f => f.value),
        options: this.apiFilters // Cada item tem {id, value}
      }]
    },
    routeLocal () {
      return this.$route.params.categoria
    }
  },
  methods: {
    async fetchProducts () {
      this.loading = true
      try {
        const data = await api.getProducts(this.$route.params.categoria, this.selectedSpecs)
        if (data) {
          this.apiCategory = data.category
          this.apiProducts = data.products || []
          this.apiFilters = data.filters || []
        }
      } catch (error) {
        console.error('Erro ao carregar produtos da API:', error)
        // Mantém arrays vazios se API falhar
        this.apiProducts = []
        this.apiFilters = []
      } finally {
        this.loading = false
        this.setPage(1)
      }
    },
    getProductImage (product) {
      // Usa URL da API (vazio se não tiver)
      return product.primaryImageUrl || ''
    },
    getProductIndex (product) {
      // Retorna o slug para navegação
      return product.slug || ''
    },
    allIncludes (arr, elms) {
      if (!arr || !elms) return false
      const map = Object.create(null)
      for (const item of arr) {
        map[item] = 1
      }
      for (const el of elms) {
        if (!map[el]) {
          return false
        }
      }
      return true
    },
    removeFilters () {
      this.inputsCheck = {}
      this.filtersChecked = []
      this.selectedSpecs = []
      this.searchProduct = ''
      // Refetch sem filtros
      this.fetchProducts()
    },
    async checkFilter (filter, option = null) {
      // Usa o id normalizado para filtrar (lowercase)
      if (option) {
        const specId = option.id
        const index = this.selectedSpecs.indexOf(specId)
        if (index === -1) {
          this.selectedSpecs.push(specId)
        } else {
          this.selectedSpecs.splice(index, 1)
        }
        await this.fetchProducts()
      }
    },
    backPage () {
      if (this.pagination.currentPage !== 1) {
        this.setPage(this.pagination.currentPage - 1)
      }
    },
    nextPage () {
      if (this.pagination.currentPage !== this.pagination.pages.length) {
        this.setPage(this.pagination.currentPage + 1)
      }
    },
    setPage (page) {
      this.pagination = this.paginator(this.products.length, page)
    },
    paginate (data) {
      return _.slice(data, this.pagination.startIndex, this.pagination.endIndex + 1)
    },
    paginator (totalItems, currentPage) {
      const startIndex = (currentPage - 1) * this.perPage
      const endIndex = Math.min(startIndex + this.perPage - 1, totalItems - 1)
      return {
        currentPage,
        startIndex,
        endIndex,
        pages: _.range(1, Math.ceil(totalItems / this.perPage) + 1)
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.products {
  justify-content: start;
  position: relative;
}
.products header{
  padding: 40px 80px;
  margin-top: 50px;
  margin-bottom: 13vw;
  text-align: left;
}
.products .content {
  max-width: 1263px;
  margin: auto;
}
@media screen and (max-width: 425px){
  .products header{
    padding: 40px 40px;
    margin-top: 70px;
  }
  #content {
    margin: 0 0;
  }
}
.products .background {
  position: absolute;
  overflow: hidden;
  top: -170px;
  left: -15vw;
  z-index: -1;
  width: 120vw;
  min-height: 430px;
  max-height: 430px;
  border-radius: 17%;
  transform: rotate(-3.5deg);
  box-shadow: 0px 3px 5px rgba(80, 80, 80, 0.52);
  img {
    width: 103%;
    margin-top: -150px;
  }
}
@media screen and (max-width: 930px) {
  .products .background {
    img {
      margin-top: 10px;
    }
  }
}
@media screen and (max-width: 730px) {
  .products .background {
    img {
      margin-top: 80px;
    }
  }
}
@media screen and (max-width: 575px) {
  .products .background {
    img {
      width: 120%;
      min-width: 664px;
      margin-left: -30px;
      margin-top: 100px;
    }
  }
}
.products #searchProduct {
  margin: 0 0 20px 5px;
  max-width: 171px;
}
.products .filters .body-3 {
  font-weight: 700;
  opacity: .75;
}
@media screen and (max-width: 800px){
  .products .background {
    min-height: 380px;
    max-height: 400px;
  }
  .content {
    display: flex;
    flex-direction: column;
    .filters {
      margin: 20px 10vw;
    }
  }
}
@media screen and (max-width: 425px){
  .products .background {
    min-height: 380px;
    max-height: 400px;
  }
}
.content .filters {
  max-width: 220px;
  margin-left: 10px;
  margin-right: -10px;
  align-items: start;
  .checkbox-group {
    margin-top: 15px;
    width: 100%;
  }
  .checkbox-group .checkbox {
    text-align: left;
    width: 100%;
    .check-input {
      display: flex;
      align-items: flex-start;
      gap: 6px;
      input[type="checkbox"] {
        margin-top: 3px;
        flex-shrink: 0;
      }
      label {
        text-align: left;
        line-height: 1.3;
        word-break: break-word;
        text-transform: capitalize;
      }
    }
  }
}
.content .labels {
  margin-bottom: 10px;
  justify-content: center;
  width: 100%;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  .label {
    cursor: pointer;
    user-select: none;
    max-width: 130px;
    padding: 1px 10px;
    font-size: 12px;
    border: solid 1px #005245;
    border-radius: 6px;
    transition: all .3s ease;
    text-decoration: none;
    color: #005245;
  }
  .label:hover {
    background-color: #005245;
    color: #FAFAFA;
  }
}
.content .products-grid {
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: dense;
  grid-auto-rows: minmax(100px, auto);
  grid-gap: 15px;
  grid-template-columns: repeat(4, 1fr);

  //--- JUST VISUAL STYLING BELOW
  margin: 0 20px;
  position: relative;
}
.content .products-loading .product {
  animation: loading-opacity 2s ease alternate-reverse infinite;
}
.content .products-loading:after {
    content: '';
    display: block;
    width: 100%;
    height: 120px;
    position: absolute;
    background: url("../assets/logo.png") no-repeat center;
    background-size: 70px;
}
@keyframes loading-opacity {
  from { opacity: 0.6; }
  to { opacity: 0.2; }
}
@media screen and (min-width: 800px){
  .content {
    margin-top: -25px !important;
  }
  .content .labels {
    margin-top: 25px;
  }
  .content .filters {
    margin-top: 25px;
  }
}
@media screen and (max-width: 800px){
  .content .filters {
    display: none;
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
    align-items: center;
    #checkbox {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      width: 90%;
      justify-content: space-around;
    }
    .subtitle-1 {
      font-size: 16px;
      line-height: 25px;
    }
    .checkbox-group {
      align-items: start;
      margin-top: 0;
      .checkbox {
        margin-left: 10px;
      }
    }
  }
  .content .labels {
    margin: 40px 0 20px 0;
    justify-content: center;
    .label {
      padding: 1px 10px;
      border: solid 1px #005245;
      border-radius: 6px;
    }
  }
}
@media screen and (max-width: 631px){
  .content .products-grid {
    grid-template-columns: repeat(3, 1fr);
    margin: 20px 2px;
  }
}
@media screen and (max-width: 477px){
  .content .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.content .products-grid .product {
  //--- JUST VISUAL STYLING BELOW
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 175px;
  .image {
    max-width: 175px;
    min-width: 147px;
    max-height: 130px;
    overflow: hidden;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 130px;
    margin-bottom: 10px;
    opacity: .9;
    transition: all .3s ease;
    div {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 130px;
      background: url("../assets/logos/logo-icon.png") no-repeat center;
      background-size: 50px;
      margin: auto;
      img {
        width: 106%;
        margin: auto;
      }
    }
  }
  .image:hover {
    opacity: 1;
  }
  .image img {
    transition: all .3s ease;
  }
  .image img:hover {
    width: 115%;
  }
}
.content .pagination {
  margin: 30px 0;
  gap: 20px;
  svg, button {
    cursor: pointer;
  }
  button {
    background-color: transparent;
    border: none;
    font-weight: 700;
    color: #505050;
    opacity: .8;
    transition: all .3s ease;
  }
  button:hover {
    opacity: 1;
  }
  .active {
    opacity: 1;
    color: #276a00;
  }
}
</style>